__turbopack_context__.v({
  "code": "CollapsibleSnippet-module__a7KVra__code",
  "container": "CollapsibleSnippet-module__a7KVra__container",
  "expanded": "CollapsibleSnippet-module__a7KVra__expanded",
  "pre": "CollapsibleSnippet-module__a7KVra__pre",
  "toggle": "CollapsibleSnippet-module__a7KVra__toggle",
});
